import styled from '@app/styled';
import { color, spacing, typography } from '@app/theme';

export const Container = styled.div`
    padding: ${spacing(1, 0)};
`;

export const InputWrapper = styled.div``;

export const Content = styled.div`
    margin-top: ${spacing(4)};
`;

export const ContentHeading = styled.div`
    ${typography('custom.descriptionMedium')}
    color: ${color('text.light.default')};
`;

export const ContentList = styled.ul`
    ${typography('custom.description')}
    color: ${color('text.light.default')};
`;

export const ContentListItem = styled.li`
    display: list-item;
    list-style-type: disc;
`;

export const ContentListItemContent = styled.div`
    min-height: 28px;
    display: flex;
    align-items: center;
`;
